import type { SpaceScale } from '../GBlockCenter';
import type { BoxProps } from '@shopify/polaris';
import type { CSSProperties } from 'react';

import { Box } from '@shopify/polaris';
import { useMemo } from 'react';

export interface GInlineCenterProps extends BoxProps {
  flexDirection?: 'row' | 'column';
  align?: 'center' | 'start' | 'end';
  inlineAlign?: 'center' | 'start' | 'end';
  width?: string;
  gap?: SpaceScale;
}

export const GInlineCenter = ({ align, inlineAlign, width, ...props }: GInlineCenterProps) => {
  const stickyStyle = useMemo<CSSProperties>(() => {
    const style: CSSProperties = {};
    return style;
  }, []);

  return (
    <div
      className="Polaris-GInlineCenter"
      style={
        {
          ...stickyStyle,
          '--gp-inline-center-box-align': align,
          '--gp-inline-center-box-inline-align': inlineAlign,
          '--gp-inline-center-box-flex-direction': props.flexDirection,
          '--gp-inline-center-box-gap': props.gap
            ? `${(Number(props.gap) * 4) / 100}px`
            : undefined,
          '--gp-inline-center-width': width,
        } as CSSProperties
      }
    >
      <Box {...props} minWidth="0" />
    </div>
  );
};
